/* Regista quick buy fixes: robust close button and fit assistant inside injected quick-buy content */
(function () {
  "use strict";

  function neutralizeQuickBuyGalleryLinks(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".quick-buy-modal .product-gallery__image[href]").forEach((link) => {
      link.dataset.registaOriginalHref = link.getAttribute("href") || "";
      link.removeAttribute("href");
      link.setAttribute("role", "presentation");
      link.setAttribute("tabindex", "-1");
    });
  }

  function closeQuickBuy(modal) {
    if (!modal) return;

    try {
      if (typeof modal.hide === "function") {
        modal.hide();
        return;
      }
    } catch (error) {}

    modal.removeAttribute("open");
    modal.innerHTML = "";
    document.documentElement.classList.remove("lock");
  }

  document.addEventListener("click", function (event) {
    const galleryLink = event.target.closest(".quick-buy-modal .product-gallery__image");
    if (galleryLink) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const closeButton = event.target.closest(".quick-buy-modal__close-button, [data-regista-quick-buy-close]");
    if (closeButton) {
      const modal = closeButton.closest("quick-buy-modal") || document.querySelector("quick-buy-modal[open]");
      if (modal) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeQuickBuy(modal);
      }
    }
  }, true);

  document.addEventListener("click", function (event) {
    const path = typeof event.composedPath === "function" ? event.composedPath() : [];
    const target = path[0];
    if (!target) return;

    const modal = document.querySelector("quick-buy-modal[open]");
    if (!modal) return;

    const isPopoverClose = path.some(function (item) {
      return item && item.matches && item.matches("x-popover");
    });

    if (isPopoverClose) return;

    const text = String(target.getAttribute && target.getAttribute("part") || "") + " " + String(target.className || "");
    if (/close-button/.test(text)) {
      event.preventDefault();
      event.stopPropagation();
      closeQuickBuy(modal);
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("quick-buy-modal[open]").forEach(closeQuickBuy);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          neutralizeQuickBuyGalleryLinks(node);
        }
      });
    });
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    neutralizeQuickBuyGalleryLinks(document);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      observer.observe(document.body, { childList: true, subtree: true });
      neutralizeQuickBuyGalleryLinks(document);
    }, { once: true });
  }

  document.addEventListener("listbox:change", function (event) {
    const option = event.target.closest('[role="option"][value]');
    const listbox = option && option.closest("x-listbox[data-option-selector]");
    if (!option || !listbox) return;

    const value = option.getAttribute("value");
    const radio = listbox.querySelector(`input[type="radio"][data-option-position][value="${CSS.escape(value)}"]`);
    if (!radio || radio.checked) return;

    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }, true);

  document.addEventListener("click", function (event) {
    const openButton = event.target.closest(".quick-buy-modal [data-regista-fit-open]");
    if (!openButton) return;

    const quickBuy = openButton.closest(".quick-buy-modal");
    const fitModal = quickBuy && quickBuy.querySelector("[data-regista-fit-modal]");

    if (fitModal && fitModal.parentElement !== document.body) {
      document.body.appendChild(fitModal);
    }
  }, true);
})();
